import React, { useContext } from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField, Stack } from "sprint-common-web";

import { UserContext } from "../../../../core/security/UserProvider";
import { useOrdersModuleApi } from "../../useOrdersModuleApi";

export interface AddAssetNoteFormProps {
    orderId: string;
    onDismiss(): void;
    onSubmit(note: string): void;
}

export const AddAssetNoteForm: React.FC<AddAssetNoteFormProps> = (props: AddAssetNoteFormProps) => {
    const { orderId, onDismiss, onSubmit } = props;

    const userContext = useContext(UserContext);

    const { errors, control, formState, reset, handleSubmit } = useForm<{ note: string }>({
        defaultValues: { note: "" },
        criteriaMode: "all"
    });

    const { addOrderNote } = useOrdersModuleApi();

    const createNote = async (inputs: { note: string }) => {
        const { note } = inputs;

        if (note) {
            await addOrderNote({
                subjectId: orderId,
                authorName: userContext.name,
                authorEmail: userContext.email,
                content: note
            });
            onSubmit(note);
        }
    };

    const clearAndDismiss = () => {
        reset();
        onDismiss();
    };

    return (
        <Form onSubmit={handleSubmit(createNote)}>
            <FormFields>
                <Stack>
                    <FormTextField
                        label="New note"
                        name="note"
                        multiline={true}
                        control={control}
                        errors={errors}
                        rules={{
                            required: "Please fill the note",
                            maxLength: { value: 500, message: "Note must not be longer than 500 characters" }
                        }}
                    />
                </Stack>
                <FormActions onCancel={clearAndDismiss} isLoading={formState.isSubmitting || formState.isValidating} />
            </FormFields>
        </Form>
    );
};
